import { Page } from "../../../components/page-base";
import { BottomContainer, BtnsContainer, Container, FormRow, RegisterInputContainer } from "./styles";
import gpv from "../../../assets/images/logo-georanking.png";
import { InputLogin } from "../components/input";
import { useState } from "react";
import ActionButton from "../components/button";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { LoginService } from "../services";

export const ForgotPassword: React.FC = () => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async () => {
    if (!email) {
      toast.error("Informe o e-mail cadastrado.");
      return;
    }
    setLoading(true);
    try {
      const ok = await LoginService.forgotPassword(email);
      if (ok) {
        navigate("/login/admin");
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <Page.Root>
      <Container>
        <FormRow>
          <div className="left-item">
            <img src={gpv} alt="" className="left-image" />
            <span className="left-title">Esqueceu a senha?</span>
            <span className="left-subtitle">
              Informe seu e-mail e enviaremos as instruções de redefinição
            </span>
          </div>
          <div className="right-item">
            <RegisterInputContainer>
              <InputLogin
                placeholder="Email"
                type="text"
                setValue={setEmail}
                value={email}
              />
            </RegisterInputContainer>
            <BtnsContainer>
              <a
                className="link"
                style={{ cursor: "pointer", fontSize: "14px", color: "#1264C7" }}
                onClick={() => navigate("/login/admin")}
              >
                Voltar ao login
              </a>
              <ActionButton label="Enviar instruções" onClick={handleSubmit} />
            </BtnsContainer>
          </div>
        </FormRow>
      </Container>

      {loading && (
        <div
          style={{
            position: "fixed",
            inset: 0,
            background: "rgba(255,255,255,0.65)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 2000,
          }}
          aria-busy
          aria-live="assertive"
        >
          <Page.Loader />
        </div>
      )}
      <BottomContainer>
        <a href="/terms-of-use" target="_blank" rel="noopener" style={{ marginRight: "1vw" }}>
          Termos de Uso
        </a>
        <a href="/privacy-policy" target="_blank" rel="noopener">
          Política de Privacidade
        </a>
      </BottomContainer>
    </Page.Root>
  );
};
